export default __webpack_public_path__ + "static/media/039-file.1c8f99aa.svg";